export default __webpack_public_path__ + "static/media/announce-product-updates-features.e9b3b340.jpg";